import React, { useEffect, useMemo } from "react"
import FormControlCustom from "../../../../components/formControlCustom"
import PropTypes from "prop-types"
import { type } from "jquery"

const SelectCurrency = ({ currencies, onChange, value, field, disabled }) => {
  
  const optionsCurrency = useMemo(() => {
    return currencies?.map((currency) => ({
      value: currency.iso,
      text: currency.iso,
    }))
  }, [currencies])
  
  if(!currencies || currencies.length < 2) return null;
  return (
    <FormControlCustom
      field={{
        ...field,
        type: 'select',
        option: optionsCurrency
      }}
      handleChange={onChange}
      value={value}
      disabled={disabled}
    />
  )
}

SelectCurrency.defaultProps = {
  currencies: [],
  onChange: () => {},
  value: '',
  field: {},
  disabled: false
}

SelectCurrency.prototype = {
  currencies: PropTypes.array,
  onChange: PropTypes.func,
  value: PropTypes.string,
  field: PropTypes.object,
  disabled: PropTypes.bool
}

export default SelectCurrency